import { formatOfferingAmountOption } from '../utils';

const accountOptionsSelectors = {
  getMassOfferingMassRequestToDate: state => state.accountOptions.massOfferingMassRequestMaxToDate,
  getMassOfferingMassRequestFromDate: state =>
    state.accountOptions.massOfferingMassRequestMinFromDate,
  isMassOfferingPhoneNumberRequired: state => state.accountOptions.massOfferingPhoneNumberRequired,
  isPreferredTimeFeatureFlagEnabled: state =>
    state.accountOptions.pastoralVisitPreferredTimeSlotsFeatureFlag,
  getPreferredTimeSlots: state => state.accountOptions.pastoralVisitPreferredTimeSlots,
  isPastoralVisitCityFeatureFlagEnabled: state => state.accountOptions.pastoralVisitCityFeatureFlag,
  getDeathPrayersTypes: state => state.accountOptions.deathPrayersTypes,
  getDeathPrayersFeatureFlag: state => state.accountOptions.deathPrayersFeatureFlag,
  isDeathPrayersPhoneFieldAvailable: state => state.accountOptions.deathPrayersFormPhoneField,
  getOptions: state => state.accountOptions,
  selectPerpetualMassFeatureFlag: state => state.accountOptions.perpetualMassOfferingFeatureFlag,
  selectPerpetualMassBeforeFormText: state => state.accountOptions.perpetualMassOfferingBeforeText,
  selectPerpetualMassOfferingAmountOption: state => {
    const perpetualMassOfferingAmountOption = state.accountOptions.perpetualMassOfferingAmount;
    return formatOfferingAmountOption(perpetualMassOfferingAmountOption);
  },
  selectPerpetualMassOfferingFormAddressField: state =>
    state.accountOptions.perpetualMassOfferingFormAddressField,
  selectPastoralVisitTextBeforeForm: state => state.accountOptions.pastoralVisitTextBeforeForm,
  selectPastoralVisitActivePeriod: state => state.accountOptions.pastoralVisitActivePeriod,
  selectPastoralVisitFeatureFlag: state => state.accountOptions.pastoralVisitFeatureFlag,
  // @TODO: USE OPTION VALUES FOR ASSOCIATION MASSES
  selectAssociationMassFeatureFlag: () => true,
  selectAssociationMassBeforeFormText: () =>
    'Każda intencja dołączona do Związku Mszalnego jest objętą sprawowaną Ofiarą Eucharystyczną odprawianą o godz. 6:50 w tygodniu w kaplicy klasztornej i o 7:00 w bazylice w niedziele i uroczystości przez 365 dni. Ofiara za zamówioną intencje jest <b>dobrowolna</b>. Można skorzystać z sum sugerowanych, wpisać dowolną swoją sumę lub wybrać opcje przekazania ofiary w późniejszym terminie.',
  selectAssociationMassOfferingAmountOption: () => {
    const associationMassOfferingAmountOption = {
      predefinedValues: [50, 100, 150],
      allowOwnAmount: true,
      minimalValue: 0,
    };
    return formatOfferingAmountOption(associationMassOfferingAmountOption);
  },
  selectMassOfferingAmountOption: state => {
    const massOfferingAmountOption = state.accountOptions.massOfferingAmount;
    return formatOfferingAmountOption(massOfferingAmountOption);
  },
  selectIsServiceFeeEnabled: state => state.accountOptions.serviceFeeEnabled,
  selectIsServiceFeeCoveredDefault: state => state.accountOptions.serviceFeeCoveredDefault,
  selectIsServiceFeeCoveredRequired: state => state.accountOptions.serviceFeeCoveredRequired,
  selectMassOfferingReservation: state => state.accountOptions.massOfferingReservation,
  selectIsInboxMassOfferingsActive: state => state.accountOptions.inboxMassOfferingFeatureFlag,
  selectIsPublicMassOfferingActive: state => state.accountOptions.publicMassOffering,
  selectMassOfferingFeatureFlag: state => state.accountOptions.massOfferingFeatureFlag,
  selectDeathPrayersAmountOption: state => {
    const deathPrayersAmountOption = state.accountOptions.deathPrayersAmount;
    return formatOfferingAmountOption(deathPrayersAmountOption);
  },
  selectDevotionTypeAmountOption: (state, devotionTypeId) => {
    const devotionTypeAmounts = state.accountOptions.devotionTypeAmount || {};
    const massOfferingAmountOption = state.accountOptions.massOfferingAmount;
    const defaultAmount = formatOfferingAmountOption(massOfferingAmountOption);

    if (!devotionTypeId) {
      return defaultAmount;
    }

    const devotionTypeAmount = devotionTypeAmounts[devotionTypeId];
    if (devotionTypeAmount) {
      return formatOfferingAmountOption(devotionTypeAmount);
    }

    return defaultAmount;
  },
  selectTimeZone: state => state.accountOptions.timeZone,
};

export default accountOptionsSelectors;
